import React from 'react';
import { Link } from 'react-router-dom';

const FavoriteBooks = ({ books, toggleFavorite }) => {
  if (books.length === 0) {
    return <div className="favorite-books">
      <h3>Список на прочтение</h3>
      <p>Добавте в список на прочтение</p>
    </div>;
  }

  return (
    <div className="favorite-books">
      <h3>Список на прочтение</h3>
      <ul>
        {books.map(book => (
          <li key={book.name}>
            <Link to={`/book/${book.name}`}>{book.title}</Link>
            <button 
              onClick={() => toggleFavorite(book.name)}
              className="small-favorite"
            >
              {book.isFavorite ? '❤️' : '♡'}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FavoriteBooks;